import _ from 'lodash'
import moment from 'moment-timezone'
import React from 'react'
import { Button, Image, Segment } from 'semantic-ui-react'

import defaultAvatar from '../../assets/images/default-avatar.png'
import { tr } from '../../helpers/languages'
import { format } from '../../helpers/timezones'

const Participant = React.forwardRef((props, ref) => {
    const today = moment()
            .tz(props.timezone)
            .startOf('day')
            .valueOf()
    // When the next session with the participant is scheduled for.
    const nextSession = _.isEmpty(props.participant.next_session) ? '-'
        : format(props.participant.next_session, props.today ? 'HH:mm' : 'DD/MM/YYYY', props.timezone, props.language)
    // The diagnosis for the participant.
    const tmp = (!_.isEmpty(props.participant.diagnosis) && global.Diagnoses) ? global.Diagnoses.filter(d => d.value === props.participant.diagnosis[0]) : []
    const diagnosis = !_.isEmpty(tmp) ? tmp[0].display : ''
    // The therapist can enter the session after its ready time and before its end time.
    const now = moment()
        .tz(props.timezone)
        .valueOf()
    const enterable = !_.isEmpty(props.participant.ready) && !_.isEmpty(props.participant.next_session_end) &&
        now >= parseInt(props.participant.ready, 10) && now < parseInt(props.participant.next_session_end, 10)
    let classes = 'participant'
    classes = `${classes} ${enterable ? 'ready' : ''}`
    classes = `${classes} ${props.last ? 'last' : ''}`
    classes = `${classes} ${props.selected ? 'selected' : ''}`
    return (
        <div ref={props.selected ? ref : undefined}>
            <Segment.Group
                className={classes}
                horizontal
                onClick={(_e) => { props.onSelectParticipant(props.participant) }}
            >
                <Segment className='picture'>
                    <Image
                        src={props.participant.image_url || defaultAvatar}
                        size='tiny'
                        circular
                    />
                </Segment>
                <Segment className='details'>
                    <Segment className='next-session'>
                       {tr(props.today ? 'NEXT_SESSION' : (props.participant.next_session < today ? 'LAST_SESSION' : 'UPCOMING_SESSION'))}:&nbsp;
                        <span className='time'>{nextSession}</span>
                    </Segment>
                    <Segment className='name'>{props.participant.name}</Segment>
                    <Segment className='diagnosis'>{props.participant.pid}</Segment>
                    <Segment className='diagnosis'>{diagnosis}</Segment>
                    {
                        enterable && (
                            <Segment className='enter-session'>
                                <Button
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        props.onEnterSession()
                                    }}
                                    disabled={!props.onEnterSession}
                                >
                                    {tr('ENTER_SESSION')}
                                </Button>
                            </Segment>
                        )
                    }
                </Segment>
            </Segment.Group>
        </div>
    )
})

export default Participant



// WEBPACK FOOTER //
// ./src/components/participants/participant.js